import {
  BusinessIcon,
  Chip,
  CouncilIcon,
  DocumentIcon,
  PlanningIcon,
  ReminderIcon,
  Stack,
  TopicIcon,
  Typography,
} from '@all-manager/design-system-v2';
import type { ReactElement } from 'react';
import type { AiChatSource, AiChatSourceType } from '../../types/aiChat.types';
import { useChatSources } from './useChatSources';

type Props = {
  sources: AiChatSource[];
};

const SOURCE_ICONS: Record<AiChatSourceType, ReactElement> = {
  subject: <TopicIcon fontSize="small" />,
  event: <PlanningIcon fontSize="small" />,
  reminder: <ReminderIcon fontSize="small" />,
  meeting: <CouncilIcon fontSize="small" />,
  document: <DocumentIcon fontSize="small" />,
  provider: <BusinessIcon fontSize="small" />,
};

export default function ChatSources(props: Props) {
  const hook = useChatSources(props);

  if (hook.links.length === 0) {
    return null;
  }

  return (
    <Stack spacing={1}>
      <Typography variant="caption">Sources</Typography>
      <Stack direction="row" spacing={1} wrap="wrap">
        {hook.links.map((link) => (
          link.isExternal ? (
            <Chip
              key={link.source.id}
              label={link.source.label}
              icon={SOURCE_ICONS[link.source.type]}
              variant="outlined"
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
            />
          ) : (
            <Chip
              key={link.source.id}
              label={link.source.label}
              icon={SOURCE_ICONS[link.source.type]}
              variant="outlined"
              href={link.href}
              onClick={(event) => hook.handleInternalClick(event, link.href)}
            />
          )
        ))}
      </Stack>
    </Stack>
  );
}
